/**
 * Cycles landing toolbar filter defaults (shared by Vuex store + Cycles UI).
 * First-visit / reset default selects the current calendar year in Period.
 */

/** @returns {{ statusTab: string, search: string, locations: string[], users: string[], periods: string[], upsiStatuses: number[] }} */
export function createInitialCyclesFilter() {
  return {
    statusTab: 'all', // 'all' | 'open' | 'closed'
    search: '',
    locations: [], // selected location _ids; [] = All
    users: [], // selected user _ids; [] = All
    periods: [String(new Date().getFullYear())], // year token; [] = All
    upsiStatuses: [], // selected UPSI stage numbers; [] = All
  };
}

/**
 * Single source of truth for store init, reset, and hasActiveFilters baseline.
 * Prefer createInitialCyclesFilter() when a fresh mutable copy is needed.
 */
export const DEFAULT_CYCLES_FILTERS = createInitialCyclesFilter();
